export default "__VITE_ASSET__rd1FC_wW__"